import { NSARouterMakerProps } from 'namirasoft-account-react';
import { NotificationSenderLayout } from '../NotificationSenderLayout';
import { NotificationSenderEntity } from '../NotificationSenderEntity';
import { NotificationSenderProps } from '../NotificationSenderProps';

interface SentTopicListPageProps extends NSARouterMakerProps, NotificationSenderProps { }

function SentTopicListPage(props: SentTopicListPageProps)
{
    return (
        <NotificationSenderLayout {...props}
            pages={{
                entity: NotificationSenderEntity.SentTopic(props),
                list: {
                    ui: {}
                }
            }}
        >
            <></>
        </NotificationSenderLayout>
    );
}

export default SentTopicListPage;